<div class="warn-dialog">
  <div class="title">
    <p>
      <img *ngIf="modalAviso" src="../../../../assets/svg/icons/warning.svg" alt="Aviso" />
      <img *ngIf="!modalAviso" src="../../../../assets/svg/icons/information.svg" alt="Aviso" />
      {{titulo}}
    </p>
    <mat-icon style="cursor: pointer; color: #5f6368" (click)="onCancel()"
      >close</mat-icon
    >
  </div>

  <hr />

  <div class="content">
    <p>{{conteudo}}</p>
  </div>

  <hr *ngIf="possuiAcoes" />

  <div *ngIf="possuiAcoes" class="modal-footer" mat-dialog-actions>
    <button *ngIf="possuiAcoes" matButton="filled" (click)="onConfirm()">{{acao}}</button>
  </div>
</div>
